<template>
  <div class="modal-cv-container">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">편의시설</div>
      <div>
        <div class="flex-between">
          <div class="flex-align">
            <lp-check-bool label="전체" :checkedVal.sync="checkedAll"></lp-check-bool>
            <button class="size-13 button is-line-grey" @click="delSelected">선택 삭제</button>
          </div>
          <div class="size-13 txt-primary unselect" @click="clickAdd">+ 편의시설 추가하기</div>
        </div>
        <div class="box-check" ref="box">
          <lp-check-bool v-for="(item,idx) in items" :key="`check-bool-${idx}`"
                         :label="item.name" :labelStyle="labelStyle"
                         :checkedVal.sync="item.selected"></lp-check-bool>
          <div v-if="vAdd" class="flex-align">
            <input type="text" class="input-border" v-model="inputValue"
                  @keyup="e => inputValue = e.target.value">
            <button class="button is-primary" style="width:44px" @click="addItem">추가</button>
            <i class="material-icons unselect" style="margin-left:12px" @click="cancelAdd">close</i>
          </div>
        </div>
      </div>
      <div class="btn-group-justify-end" style="padding-top:12px">
        <button class="button is-light" @click="clickCancel">취소</button>
        <button class="button is-primary" @click="clickAccept">확인</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  export default {
    name: 'ModalConvenience',
    components: {
      LpCheckBool,
      SweetModal
    },
    props: {
      convs: {
        type: Array
      }
    },
    data() {
      return {
        checkedAll: false,
        labelStyle: {
          fontSize: '13px',
          color: '#363636'
        },
        vAdd: false,
        items: []
      }
    },
    methods: {
      open() {
        this.items = this.convs.map(i=> {
          i.selected = false;
          return i;
        });
        this.$refs.modal.open();
      },
      clickCancel() {
        this.$refs.modal.close();
      },
      clickAccept() {
        this.$emit('accept', this.cloneItem(this.items));
        this.$refs.modal.close();
      },
      addItem() {
        this.items.push({
          name: this.inputValue,
          checked: false,
          selected: false
        })
        this.cancelAdd();
      },
      clickAdd() {
        this.inputValue = '';
        this.vAdd=true;
        setTimeout(()=>{
          this.$refs.box.scrollTo(0,100000);
        },300);
      },
      cancelAdd() {
        this.inputValue = '';
        this.vAdd=false;
      },
      delSelected() {
        this.items = this.items.filter(i => !i.selected);
      }
    },
    watch: {
      checkedAll(n) {
        this.items.forEach(i => i.selected = n)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-cv-container
    color #363636
    font-size 13px

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .box-check
    background-color #f5f5f5
    padding 12px
    margin-top 12px
    gap 12px 0
    display grid
    max-height 30vh
    overflow-y auto


  .is-line-grey
    width 87px
    height 30px
    margin-left 12px

  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 210px
  .input-border:focus
    outline none
</style>
<style lang="stylus">
  .modal-cv-container
    .sweet-modal.is-alert
      width 544px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
